import { RoomBasketSessionModel } from './room-basket-session.model';
import { RoomBasketModel } from './room-basket.model';
import { RoomSearchModel } from './room-search.model';
import { RoomDescriptionModel } from './room-description.model';
import { RoomModel } from './room.model';

export const createRoomBasketSession = (
  payload: any,
): RoomBasketSessionModel => {
  return {
    roomId: payload.roomId,
    quantitiesByOccupancyId: payload.quantitiesByOccupancyId,
    extras: payload.extras,
  };
};

export const createRoomBasket = (payload: any): RoomBasketModel => {
  return {
    roomId: payload.roomId,
    name: payload.name,
    type: payload.description.type,
    productId: payload.productId,
    defaultOccupancy: payload.defaultOccupancy,
    occupancies: payload.occupancies,
    extras: payload.extras,
    summary: payload.description.summary,
    pictures: payload.description.pictures,
    amenities: payload.description.amenities,
    beds: payload.description.beds,
    surfaceArea: payload.description.area,
  };
};

export const createRoomSearch = (payload: any): RoomSearchModel => {
  return {
    roomId: payload.roomId,
    productId: payload.productId,
    name: payload.name,
    displayType: payload.displayType,
    availabilityType: payload.availabilityType,
    rates: payload.rates,
    defaultOccupancy: payload.defaultOccupancy,
    sortOrder: payload.sortOrder,
  };
};

export const createRoomDescription = (payload: any): RoomDescriptionModel => {
  return {
    roomId: payload.roomId,
    hotelId: payload.hotelId,
    name: payload.name,
    totalCount: payload.information.totalCount,
    type: payload.information.type,
    category: payload.information.category,
    qualifier: payload.information.qualifier,
    surfaceArea: payload.information.surfaceArea,
    bedding: payload.information.bedding,
    code: payload.information.code,
    summary: payload.information.summary,
    pictures: payload.information.pictures,
    displayedPersonCount: payload.information.displayedPersonCount,
    sortOrder: payload.information.sortOrder,
    services: payload.services,
    occupancies: payload.occupancies,
    extraIds: payload.extraIds,
    rateIds: payload.rateIds,
  };
};

export const createRoom = (
  roomDescription: RoomDescriptionModel,
  roomSearch?: RoomSearchModel,
): RoomModel => {
  return {
    roomId: roomDescription.roomId,
    name: roomDescription.name,
    totalCount: roomDescription.totalCount,
    bedding: roomDescription.bedding,
    code: roomDescription?.code,
    occupancies: roomDescription.occupancies,
    pictures: roomDescription.pictures,
    surfaceArea: roomDescription.surfaceArea,
    summary: roomDescription.summary,
    type: roomDescription.type,
    services: roomDescription.services,
    extraIds: roomDescription.extraIds,
    category: roomDescription.category,
    qualifier: roomDescription.qualifier,
    sortOrder: roomDescription.sortOrder,
    rates: roomSearch?.rates ?? [], //TODO CHECK FIX
  };
};
